import { createReducer } from "@reduxjs/toolkit";

import {
  getCardDetails,
  getCardDetailsSuccess,
  getCardDetailsFailure,
  getCardDetailsReset,
} from "./actions";

const initialState = {
  id: undefined,
  cardId: undefined,
  fullName: undefined,
  country: undefined,
  addressLineFirst: undefined,
  addressLineSecond: undefined,
  postalCode: undefined,
  lastFourNumbers: undefined,
  paymentSystem: undefined,
  expMonth: undefined,
  expYear: undefined,
  isLoading: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getCardDetails.type, (state) => {
      state.isLoading = true;
    })
    .addCase(getCardDetailsSuccess.type, (state, { payload }) => ({
      ...payload,
      isLoading: false,
    }))
    .addCase(getCardDetailsFailure.type, (state) => {
      state.isLoading = false;
    })
    .addCase(getCardDetailsReset.type, () => initialState);
});
